import React, { Component } from 'react';

import UnlockRequest from "components/UnlockRequest/UnlockRequest";

export default class UnlockRequestView extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="header">Habilitar saldo pendiente</h1>
                    </div>
                </div>

                <UnlockRequest />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/UnlockRequestView/UnlockRequestView.jsx